import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-add-document-legal-requirement',
  templateUrl: './add-document.component.html',
  styleUrls: ['./add-document.component.scss']
})
export class AddDocumentComponent implements OnInit {
  loading = false
  date = new Date()
  file: any = null;

  constructor(
    protected ref: NbDialogRef<AddDocumentComponent>,
  ) { }

  close() { this.ref.close(false); }

  ngOnInit() { }

  async loadImage(event: any) {
    if (!event.target.files.length) return;
    this.file = event.target.files[0]
  }

  store () {
    this.ref.close({ file: this.file, date: this.date })
  }

}
